import RichTextSerializer from '@components/RichTextSerializer'

// Brands List
interface Props {
	slice: any
}

export default function FAQ({ slice }: Props) {
	// console.log('FAQ Slice ->', slice)
	const { primary, items } = slice

	return (
		<section className="faq section">
			<div className="container max-w-screen-sm">
				{/* Title */}
				{primary.section_title?.[0] && (
					<h2 className="title text-4xl mb-6 text-center">{primary.section_title[0].text}</h2>
				)}

				{/* <pre>{JSON.stringify(slice, null, 2)}</pre> */}

				<div className="space-y-6">
					{items.map((faqItem: any, i: number) => (
						<details
							// eslint-disable-next-line react/no-array-index-key
							key={i}
							className="faq-item"
						>
							<summary>
								{/* Question */}
								{faqItem.question?.[0] && (
									<h3 className="font-medium inline-block">{faqItem.question[0].text}</h3>
								)}
								<i className="fa-light fa-circle-plus fa-fw" />
							</summary>

							{/* Answer */}
							{faqItem.answer?.[0] && (
								<div className="faq-item-body">
									<RichTextSerializer content={faqItem.answer} />
								</div>
							)}

							{/* <pre>{JSON.stringify(brand, null, 2)}</pre> */}
						</details>
					))}
				</div>
			</div>
		</section>
	)
}
